<app-vvr-icon [full]="true" [dark]="true" [overlay]="true" [shadow]="false"></app-vvr-icon>
<div class="login-background">
    <div class="login-block">
        <div id="errorMessage">
            @if (requestState() === RequestRestorePasswordState.SendedEmail) {
                Er is een e-mail verstuurd naar <b>{{form.value.email}}</b>.
                    Via de link in deze e-mail kun je een nieuw wachtwoord instellen.
                <br><br>
                <b>E-mail niet ontvangen?</b><br>
                Controleer of deze in spam terecht is gekomen en voeg
                <a href="mailto:app@vvr.nl">app&#64;vvr.nl</a> toe aan de lijst met veilige afzenders.
                <br><br>
                <a routerLink="/login" class="textlink back">Terug naar het inlogscherm</a>
            } @else if (requestState() === RequestRestorePasswordState.SendEmailFail) {
                Het is niet gelukt om een e-mail te versturen. Probeer het nog een keer, want het ligt niet aan jou.
            }
        </div>
        @if (requestState() === RequestRestorePasswordState.FillInEmail || requestState() === RequestRestorePasswordState.SendingEmail) {
            <form [formGroup]="form">
                <div class="title">
                    <h1 class="h4 condensed">Wachtwoord vergeten</h1>
                    <p>Vul hier uw e-mailadres in om uw wachtwoord te resetten.</p>
                </div>
                <mat-form-field appearance="fill" id="email">
                    <mat-label>E-mailadres</mat-label>
                    <input formControlName="email" matInput name="email" placeholder="Vul uw e-mailadres in" type="text">
                    <mat-error>Vul een correct e-mailadres in</mat-error>
                </mat-form-field>
                <div class="login-buttons">
                    <button
                        (click)="requestPasswordEmail()"
                        [disabled]="form.invalid || requestState() === RequestRestorePasswordState.SendingEmail"
                        color="primary"
                        id="btn-request-password"
                        mat-raised-button>
                        @if (requestState() === RequestRestorePasswordState.FillInEmail) {
                            Wachtwoord opvragen
                        } @else if (requestState() === RequestRestorePasswordState.SendingEmail) {
                            Link wordt verstuurd...
                        }
                    </button>
                </div>
            </form>
        }
    </div>
</div>
